import { render, staticRenderFns } from "./PackingManifestPage.vue?vue&type=template&id=955e658e"
import script from "./PackingManifestPage.vue?vue&type=script&lang=js"
export * from "./PackingManifestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports